"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderText = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../constants");
const renderInlineText_1 = require("./renderInlineText");
const renderText = (value, emptyValue = constants_1.EMPTY_TEXT.dash) => {
    if (!value) {
        return renderInlineText_1.renderInlineText(emptyValue);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, value.split('\n').map((text, idx) => (react_1.default.createElement(react_1.default.Fragment, { key: `${text}-${idx}` }, renderInlineText_1.renderInlineText(text, emptyValue))))));
};
exports.renderText = renderText;
//# sourceMappingURL=renderText.js.map